import { Injectable } from '@angular/core';
import { ApiService } from '../core/services/api.service';
import { ConfigService } from '../core/services/config.service';
import { Observable } from 'rxjs';
import { SearchCriteria } from '../core/models/search-criteria';
import { WantedCredit} from '../core/models/wantedcredit';

const requestIdStorageKey = 'wanted-credit-request-id';
@Injectable({
  providedIn: 'root'
})

export class WantedcreditService {
  #requestId;
  selectedCredits: WantedCredit[] = [];
  
  ecoResults: any = null;
  speciesResults: any = null;
  speciesResultsV: any = null;
  searchCriteria: SearchCriteria = null;
  specieSearchCriteria: SearchCriteria = null;
  constructor(private apiService:ApiService, private configService:ConfigService) {
  }

  get requestId(){
    return this.#requestId ??
    this.#requestId ?? sessionStorage.getItem(requestIdStorageKey)
  }

  set requestId(val) {
    this.#requestId = val;
    val ? sessionStorage.setItem(requestIdStorageKey, val) : sessionStorage.removeItem(requestIdStorageKey);
  }

  clearRequestId() {
    this.requestId = undefined;
  }
 
  public search(searchCriteria: SearchCriteria): Observable<any> {
    return this.apiService.findByPost(this.configService.WantedCreditsUrl,searchCriteria);
  }

  public getTradingGroupsBySubregion(subregion: string): Observable<any> {
    return this.apiService.findAll(this.configService.TradingGroupsUrl+"/"+subregion);
  }
}
